module.exports = __webpack_public_path__ + "static/media/alert.b21a2dad.svg";